export const MODULE_WRAPPER_VIEW_MODE_CLASSES = {
  desktop: 'module-desktop-view',
  mobile: 'module-mobile-view',
};
